import React, { useState } from 'react';
import { Modal } from '@mui/material';
import { Buttons } from './Buttons';
import CityFilter from './CityFilter';
import CensusFilters from './Filters/CensusFilters';
import CensusYearIndicator from './Filters/CensusYearIndicator';

const modalStyle = {
    position: 'absolute',
    top: '10%',
    left: '50%',
    transform: 'translate(-50%, 0)',
    backgroundColor: '#fff',
    padding: '24px',
    borderRadius: '8px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    maxWidth: '90vw',
    width: '80%'
};

const CensusChartsContainer = ({ title, className, children }) => {
    const [open, setOpen] = useState(false);
    const [isCityFilterOpen, setIsCityFilterOpen] = useState(false);

    return (
        <div className={`${className}`}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '16px'
                }}
            >
                <h2 className="title-dashboards">{title}</h2>
                <Buttons
                    onClickFilters={() => setOpen(true)}
                    onClickCityFilter={() => setIsCityFilterOpen(true)}
                />
                <Modal open={open} onClose={() => setOpen(false)}>
                    <div style={modalStyle}>
                        <CensusFilters />
                    </div>
                </Modal>
                <Modal
                    open={isCityFilterOpen}
                    onClose={() => setIsCityFilterOpen(false)}
                >
                    <div style={modalStyle}>
                        <CityFilter />
                    </div>
                </Modal>
            </div>

            <CensusYearIndicator />

            <div className="charts-container-dashboards">
                {/* O container compartilhado centraliza e encolhe os filhos; as páginas do Censo usam a largura toda. */}
                <div className="censo-page">{children}</div>
            </div>
        </div>
    );
};

export default CensusChartsContainer;
